import { Column, NotFound } from "@dgs/core";
import { useState } from "react";
import { Navigate, Route, Routes } from "react-router";
import styled from "styled-components";
import { AnalyticsFilter } from "./AnalyticsFilter";
import { AnalyticsForEvents } from "./AnalyticsForEvents";
import { EventAnalyticsFilterValues } from "./analyticsTypes";
import { BudgetAnalytics } from "./budget/BudgetAnalytics";
import { FeedbackAnalyticsPage } from "./feedback/FeedbackAnalyticsPage";
import { initialEventAnalyticsFilter } from "./shared";

const Wrapper = styled(Column)`
	margin: ${({ theme }) => theme.spacing(8)};
`;

const BudgetWrapper = styled(Wrapper)`
	flex-wrap: inherit;
`;

export function AnalyticsPage() {
	const [filter, setFilter] = useState<EventAnalyticsFilterValues>(initialEventAnalyticsFilter);

	return (
		<Routes>
			<Route index element={<Navigate replace to="./events" />} />
			<Route
				path="events"
				element={
					<Wrapper>
						<AnalyticsFilter
							filter={filter}
							onSubmit={async (values) => {
								setFilter(values);
							}}
						/>
						<AnalyticsForEvents filter={filter} />
					</Wrapper>
				}
			/>
			<Route
				path="budget"
				element={
					<BudgetWrapper>
						<AnalyticsFilter
							filter={filter}
							onSubmit={async (values) => {
								setFilter(values);
							}}
						/>
						<BudgetAnalytics filter={filter} />
					</BudgetWrapper>
				}
			/>
			<Route
				path="feedback"
				element={
					<Wrapper>
						<AnalyticsFilter
							filter={filter}
							onSubmit={async (values) => {
								setFilter(values);
							}}
						/>
						<FeedbackAnalyticsPage />
					</Wrapper>
				}
			/>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}
